import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/index.css';
import App from './containers/App/App';
// import registerServiceWorker from './registerServiceWorker';
import ErrorBoundary from './components/Errors/ErrorBoundary';


ReactDOM.render(<ErrorBoundary><App /></ErrorBoundary>, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js